import { render } from "./Product.vue?vue&type=template&id=dfbe8752"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=dfbe8752&lang=scss"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__